import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RefundMeasManagerDecision, FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ReleaseRefundRequestDTO, ReleaseRefundAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-measurement-manager',
  templateUrl: './measurement-manager.component.html'
})
export class MeasurementManagerComponent {
  submitted = false;
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  refundRequestObj: ReleaseRefundRequestDTO = new ReleaseRefundRequestDTO();
  refundAdminObj: ReleaseRefundAdminDTO = new ReleaseRefundAdminDTO();
  decision = RefundMeasManagerDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  user: User = new User();
  refundMeasManagerForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  showRestudyDecision: boolean = false;


  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private longhaulserv: LongHaulService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
  }
  ngOnInit() {
    this.buildForm(null);
  }

  buildForm(decision) {
    this.refundMeasManagerForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == RefundMeasManagerDecision.MeasManager_Approve) {
      this.refundMeasManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
      });
    }
    else if (decision == RefundMeasManagerDecision.MeasManager_MoreInformation) {
      this.refundMeasManagerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
  }
  get form() {
    return this.refundMeasManagerForm.controls;
  }

  changeDecision(value) {
    this.buildForm(value);
    this.refundMeasManagerForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  getRequest() {
    this.longhaulserv.GetRefundRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.refundRequestObj = this.responseObj.Data;
          this.requestStatus = this.refundRequestObj.BaseRequest.StatusId;
          this.isLoaded = true;
          if (this.refundRequestObj.ReleaseRestudyRequestId != null) {
            this.showRestudyDecision = true;
          }
          if (history.state.data && history.state.data.isCompleted) {
            this.decisionValue = this.refundRequestObj.MeasManagerDecision;
            if (this.refundRequestObj.MeasManagerDecision == RefundMeasManagerDecision.MeasManager_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.refundMeasManagerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.refundRequestObj.MeasManagerNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.refundMeasManagerForm.patchValue({
                Decision: this.decisionValue,
              });
            }
            this.formMode = FormMode.Readonly;
            this.refundMeasManagerForm.disable();
          }
          else if(this.requestStatus == ServiceStatus.Refund_PendingMeasurementManager){
            this.formMode = FormMode.Add;
            this.refundMeasManagerForm.enable();
          }
          else{
            this.formMode = FormMode.Readonly;
            this.refundMeasManagerForm.disable();
            this.decisionValue = this.refundRequestObj.MeasManagerDecision;
            if (this.refundRequestObj.MeasManagerDecision == RefundMeasManagerDecision.MeasManager_MoreInformation) {
              this.buildForm(this.decisionValue);
              this.refundMeasManagerForm.patchValue({
                Decision: this.decisionValue ,
                MoreInformation: this.refundRequestObj.MeasManagerNotes
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.refundMeasManagerForm.patchValue({
                Decision: this.decisionValue,
              });
            }

          }
        }
      }
    )
  }

  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.refundMeasManagerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.refundAdminObj.AdminEmail = this.user.UserName;
    this.refundAdminObj.Id = this.baseRequestId;
    this.refundAdminObj.MeasManagerDecision = this.decisionValue;
    if (this.decisionValue == RefundMeasManagerDecision.MeasManager_MoreInformation) {
      this.refundAdminObj.MeasManagerNotes = this.refundMeasManagerForm.controls.MoreInformation.value;
    }

    this.longhaulserv.SubmitRefundMeasManagerDecision(this.refundAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.refundMeasManagerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }

}
